import React from "react";
import PropTypes from "prop-types";
import { Alert, Col, Row } from "react-bootstrap";

export default function Information(props) {
  return (
    <Alert variant="info">
      <Row className="align-items-center">
        <Col>
          {props.title ? <Alert.Heading>{props.title}</Alert.Heading> : null}
          {props.children}
        </Col>
      </Row>
    </Alert>
  );
}

Information.propTypes = {
  title: PropTypes.string,
};
